import { render, staticRenderFns } from "./multiSuccessView.vue?vue&type=template&id=c8c4bcee&"
import script from "./multiSuccessView.vue?vue&type=script&lang=js&"
export * from "./multiSuccessView.vue?vue&type=script&lang=js&"
import style0 from "./multiSuccessView.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports